export default {
  articles: [],
  media: [],
  apiCallsInProgress: 0,
};
